import {
  authHeader,
  handleResponse,
  errorOnActivation,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// SaLimited Release By Serial Number
function getSaLimitedReleaseDetail(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createSaLimitedReleaseDetail(requestBody, queryParams) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version } = queryParams;
  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editSaLimitedReleaseDetail(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteSaLimitedReleaseDetail(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function activateSaLimitedReleaseDetail(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/${version}/${release}/activate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(errorOnActivation)
    .then((data) => {
      return data;
    });
}

function deactivateSaLimitedReleaseDetail(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/analyzers/sa/limited/${version}/${release}/deactivate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const saLimitedReleasesDetailService = {
  getSaLimitedReleaseDetail,
  createSaLimitedReleaseDetail,
  editSaLimitedReleaseDetail,
  deleteSaLimitedReleaseDetail,
  activateSaLimitedReleaseDetail,
  deactivateSaLimitedReleaseDetail,
};
